import type { ReactNode } from "react";

import { cn } from "../lib/cn";

export interface HelpTextProps {
  children: ReactNode;
  tone?: "muted" | "error";
  className?: string;
}

/** Short explanation under or between controls; `error` tone is announced to assistive technology. */
export function HelpText({ children, tone = "muted", className }: HelpTextProps) {
  return (
    <p
      role={tone === "error" ? "alert" : undefined}
      className={cn(
        tone === "error"
          ? "rounded-control border border-status-error/30 bg-status-error/10 px-3 py-2 text-xs text-status-error-text"
          : "text-xs leading-5 text-muted",
        className,
      )}
    >
      {children}
    </p>
  );
}
